import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const CustomDomainHeader = props => {
  const { classes } = props
  return (
    <div className={classes.customDomain__root}>
      <div className={classes.customDomain__headerWithIcon}>
        <Typography
          fontSize={'18px'}
          fontWeight={500}
          style={{
            padding: '8px 0px',
          }}
        >
          Custom Domain
        </Typography>
      </div>
      <Typography color={'#637381'} fontSize={'13px'} fontWeight={400}>
        For instructions on adding a CNAME record to your DNS records, please
        refer to
        <a
          href="https://intercom.help/mini-course-generator/en/articles/7864258-customizing-links-with-custom-domain-cname"
          target="_blank"
        >
          {' '}
          this article.
        </a>
      </Typography>
    </div>
  )
}

export default withStyles(styles)(CustomDomainHeader)
